import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/usr/users', params),
    getById: (id) => Api.get('/usr/user/' + id, null),
    save: (entity) => Api.post('/usr/user/new', entity),
    update: (id, entity) => Api.put('/usr/user/' + id, entity),
    delete: (id) => Api.delete('/usr/user/' + id),
    restoreDeleted: (id, params) => Api.post(`/usr/user/${id}/restore`, params),
    search: (searchText, params) => Api.get('/usr/users/search', {q: searchText, ...params}),
    searchTrainers: (searchText) => Api.get('/usr/users/search', {q: searchText, onlyTrainers: true}),
    importUsers: (formData) => Api.upload('/usr/users/import', formData),
    getImportHeaders: () => Api.get('/usr/users/import/template'),
    passwordReset: (params) => Api.post('/usr/password/reset', params),
    changePassword: (params) => Api.post('/usr/password/change', params),
    sendWelcomeEmail: (userId) => Api.post(`/usr/user/welcomeemail/${userId}`),
    sendMissingWelcomeEmails: () => Api.post('/usr/welcomeemails/missing'),
    syncWithIAM: () => Api.post('/usr/user/iamsync'),
    getCurrentUser: () => Api.get('/api/usr/profile',null),
    updateProfile: (data) => Api.put('/usr/profile', data),
    validateUsername: (username, firstName, lastName) => Api.get(`/usr/user/username/${username}/validate`, {firstName, lastName}),
    getTrainers: (params) =>  Api.get('/usr/users/trainers', params),
    getManagers: (params) => Api.get('/usr/users/managers', params),
    addManager: (id, params) => Api.post('/usr/user/' + id + '/manager', params),
    removeManager: (id, managerId) => Api.delete('/usr/user/' + id + '/manager/' + managerId),
    addDepartment: (id, params) => Api.post('/usr/user/' + id + '/department', params),
    removeDepartment: (id, departmentId) => Api.delete(`/usr/user/${id}/department/${departmentId}`),
    addGroup: (id, params) => Api.post('/usr/user/' + id + '/usergroup', params),
    removeGroup: (id, groupId) => Api.delete('/usr/user/' + id + '/usergroup/' + groupId),
    getAttributes: () => Api.get('/usr/attributes'),
    getActiveAttributes: () => Api.get('/usr/attributes/active'),
    getUserEditableAttributes: () => Api.get('/usr/attributes/user-editable'),
    setAttributeActive: (id, params) => Api.put(`/usr/attribute/${id}/setactive`, params),
    setAttributeRequired: (id, params) => Api.put(`/usr/attribute/${id}/setrequired`, params),
    setAttributeUserEditable: (code, params) => Api.put(`/usr/attribute/${code}/set-user-editable`, params),
    setAttributeRegistrationField: (code, params) => Api.put(`/usr/attribute/${code}/set-shown-on-registration`, params),
    getUserSkill: (id, skillId) => Api.get(`/usr/user/${id}/skill/${skillId}`),
    getSkillsByUser: (id, params) => Api.get(`/usr/user/${id}/skills`, params),
    searchSkillsByUser: (id, searchText, params) => Api.get(`/usr/user/${id}/skills/search`, {q: searchText, ...params}),
    addSkill: (id, skillId, params) => Api.post('/usr/user/' + id + '/skill/' + skillId, params),
    updateSkill: (id, skillId, params) => Api.post(`/usr/user/${id}/skill/${skillId}/update`, params),
    removeSkill: (id, skillId) => Api.delete(`/usr/user/${id}/skill/${skillId}`),
    getCount: () => Api.get('/usr/users/count', null),
    getArchivedCount: () => Api.get('/usr/users/countArchived'),
    getVisitStats: () => Api.get('/usr/users/visit-stats'),
    addCompliance: (userId, complianceId) => Api.post(`/training/user/${userId}/compliance/${complianceId}`),
    listCompliances: (userId) => Api.get(`/training/user/${userId}/compliances`),
    removeCompliance: (userId, complianceId) => Api.delete(`/training/user/${userId}/compliance/${complianceId}`),
    getAuthTokenCount: () => Api.get('/usr/tokens/count'),
    clearAuthTokens: () => Api.post('/usr/tokens/clear'),
    listAuthMethods: () => Api.get('/usr/authmethods')
};
